export const APPROVAL_QUERY_PREFIX = 'open-enrollment' as const

export const APPROVAL_QUERY_KEYS = {
  all: [APPROVAL_QUERY_PREFIX, 'oep-approval'] as const,
  auditTrail: (clientPublicKey: string) =>
    [
      APPROVAL_QUERY_PREFIX,
      'oep-approval',
      'audit-trail',
      clientPublicKey,
    ] as const,
  // EMS-10557: keyed by the OEP id (oep_documents.oep_id), not the plan year.
  oepDocument: (clientPublicKey: string, oepId: string) =>
    [
      APPROVAL_QUERY_PREFIX,
      'oep-approval',
      'oep-document',
      clientPublicKey,
      oepId,
    ] as const,
  // Client-scoped prefix (all plan years). Use for invalidation so a write from a
  // context that derives oepYear differently still matches the reader's query.
  oepDocumentByClient: (clientPublicKey: string) =>
    [
      APPROVAL_QUERY_PREFIX,
      'oep-approval',
      'oep-document',
      clientPublicKey,
    ] as const,
  // The Analysis Upload section's own table (EMS-10154) — every non-deleted
  // document for one OEP (EMS-10573), distinct from oepDocument's
  // single-latest shape. Omit oepId for the per-client prefix: mutations
  // invalidate with it so every OEP's cached list refreshes.
  oepDocumentList: (clientPublicKey: string, oepId?: string) =>
    oepId === undefined
      ? ([
          APPROVAL_QUERY_PREFIX,
          'oep-approval',
          'oep-document-list',
          clientPublicKey,
        ] as const)
      : ([
          APPROVAL_QUERY_PREFIX,
          'oep-approval',
          'oep-document-list',
          clientPublicKey,
          oepId,
        ] as const),
  // The Analysis File detail popup's parsed-content grid (EMS-10154) — mocked
  // server-side, keyed per document so each popup caches independently.
  oepDocumentDetails: (clientPublicKey: string, documentId: string) =>
    [
      APPROVAL_QUERY_PREFIX,
      'oep-approval',
      'oep-document-details',
      clientPublicKey,
      documentId,
    ] as const,
  oepStatusOverride: (clientPublicKey: string) =>
    [
      APPROVAL_QUERY_PREFIX,
      'oep-approval',
      'oep-status-override',
      clientPublicKey,
    ] as const,
  latestTargetFileJob: (clientPublicKey: string) =>
    [
      APPROVAL_QUERY_PREFIX,
      'oep-approval',
      'latest-target-file-job',
      clientPublicKey,
    ] as const,
  latestAbp5FileJob: (clientPublicKey: string) =>
    [
      APPROVAL_QUERY_PREFIX,
      'oep-approval',
      'latest-abp5-file-job',
      clientPublicKey,
    ] as const,
  /** Latest ABP-5 job per analysis documentId (Analysis Upload table). */
  abp5FileJobsByDocument: (clientPublicKey: string) =>
    [
      APPROVAL_QUERY_PREFIX,
      'oep-approval',
      'abp5-file-jobs-by-document',
      clientPublicKey,
    ] as const,
  // Analysis Upload table's per-document processing-status poll (EMS-10185 US2) —
  // keyed per document so each row's poll caches independently.
  oepDocumentProcessingStatus: (clientPublicKey: string, documentId: string) =>
    [
      APPROVAL_QUERY_PREFIX,
      'oep-approval',
      'oep-document-processing-status',
      clientPublicKey,
      documentId,
    ] as const,
  eligibleEmployeeCount: (clientPublicKey: string) =>
    [
      APPROVAL_QUERY_PREFIX,
      'oep-approval',
      'eligible-employee-count',
      clientPublicKey,
    ] as const,
} as const
